import { useParams, Link } from 'react-router-dom'
import Iso8583BitmapParser from './tools/Iso8583Bitmap'
import Iso8583Parser from './tools/Iso8583Parser'
import TlvParser from './tools/TlvParser'
import HostLog from './tools/HostLog'

const toolTitles: Record<string, string> = {
  'iso8583-bitmap': 'Bitmap Parser',
  'iso-field-parser': 'Field Parser',
  tlv: 'TLV Parser',
  hostlog: 'Host Log Viewer',
}

export default function ToolDetail() {
  const { tool } = useParams<{ tool: string }>()

  const renderTool = () => {
    switch (tool) {
      case 'iso8583-bitmap':
        return <Iso8583BitmapParser />
      case 'iso-field-parser':
        return <Iso8583Parser />
      case 'tlv':
        return <TlvParser />
      case 'hostlog':
        return <HostLog />
      default:
        return (
          <div className="flex flex-col items-center justify-center py-24 text-center">
            <p className="text-lg font-semibold text-gray-700">Tool not found</p>
            <Link to="/tools" className="mt-4 text-indigo-600 hover:underline">
              Back to Tools
            </Link>
          </div>
        )
    }
  }

  return (
    <main className="mx-auto max-w-5xl px-6 py-8 lg:px-8">
      <div className="mb-6">
        <Link
          to="/tools"
          className="text-sm text-indigo-600 hover:underline"
        >
          ← Back to Tools
        </Link>
        {tool && toolTitles[tool] && (
          <h1 className="mt-2 text-xl font-bold text-gray-900">{toolTitles[tool]}</h1>
        )}
      </div>

      {renderTool()}
    </main>
  )
}
